import React from "react";

export default function MySQL_GREATEST() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MySQL_GREATEST</h1>
      <p>This is the MySQL_GREATEST component generated from the SQL JSON.</p>
    </div>
  );
}
